export const vblur = {
	mounted: function (el) {
		el.onfocus = (ev) => ev.target.blur();
	}
};
